import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=66872344&scoped=true&"
import script from "./activityList.vue?vue&type=script&lang=js&"
export * from "./activityList.vue?vue&type=script&lang=js&"
import style0 from "./activityList.vue?vue&type=style&index=0&id=66872344&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66872344",
  null
  
)

export default component.exports